import { forwardRef } from 'react'

type BackButtonPropTypes = {
  fill?: string
  size?: number
  onClick: (e?: React.MouseEvent<HTMLButtonElement>) => void
  testLocator?: string
  'aria-label'?: string
  /** Hint announced after name + role (maps to accessibilityHint). */
  'aria-description'?: string
  autoFocus?: boolean
}

const BackButton = forwardRef<HTMLButtonElement, BackButtonPropTypes>(function BackButton(
  {
    fill = '#000000',
    size = 24,
    onClick,
    testLocator,
    'aria-label': ariaLabel = 'Back',
    'aria-description': ariaDescription,
    autoFocus = false
  },
  ref
) {
  return (
    <button
      ref={ref}
      type='button'
      aria-label={ariaLabel}
      aria-description={ariaDescription}
      autoFocus={autoFocus}
      className='border-none bg-transparent p-0 focus:outline-none hover:outline-none flex items-center justify-center cursor-pointer'
      style={{ width: size, height: size }}
      onClick={(e: React.MouseEvent<HTMLButtonElement>) => onClick(e)}
      {...(testLocator ? { 'test-locator': testLocator } : {})}
    >
      <svg
        width='19'
        height='18'
        viewBox='0 0 19 18'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
        aria-hidden='true'
        focusable='false'
      >
        <path
          d='M10.457.38a1.348 1.348 0 0 0-.438-.281A1.397 1.397 0 0 0 8.55.38L.487 8.089c-.126.12-.226.261-.294.418a1.236 1.236 0 0 0 .294 1.406l8.062 7.71a1.404 1.404 0 0 0 1.908 0c.125-.12.224-.263.292-.42a1.24 1.24 0 0 0 0-.987 1.287 1.287 0 0 0-.292-.418l-5.2-4.96a.324.324 0 0 1 0-.36.32.32 0 0 1 .084-.12.34.34 0 0 1 .131-.072h12.092c.357 0 .698-.136.95-.376.253-.241.394-.568.394-.909 0-.34-.142-.667-.393-.908a1.375 1.375 0 0 0-.95-.377H5.471a.347.347 0 0 1-.185-.052.325.325 0 0 1-.124-.14.324.324 0 0 1 0-.36l5.294-4.96c.126-.119.226-.261.294-.418a1.236 1.236 0 0 0 0-.988 1.283 1.283 0 0 0-.294-.418Z'
          fill={fill}
        />
      </svg>
    </button>
  )
})

export default BackButton
